module.exports = __webpack_public_path__ + "static/media/cockroach(9).400c02de.PNG";